import { isNullOrUndefined } from '@as-react/common-utils';
import { MAX_NUMBER_OF_ARTICLES_IN_LISTER_PAGE_DEFAULT } from '../constants/ProductConstants';
export const generateAbsoluteUrl = (canonicalUrl, page, size) => {
    let params = [];
    if (!isNullOrUndefined(page) && page > 0) {
        params = [...params, `page=${page}`];
    }
    if (!isNullOrUndefined(size) && size !== MAX_NUMBER_OF_ARTICLES_IN_LISTER_PAGE_DEFAULT) {
        params = [...params, `size=${size}`];
    }
    if (params.length > 0) {
        return `${canonicalUrl}?${params.join('&')}`;
    }
    return canonicalUrl;
};
export const getQuerystringByName = (queryString, name) => {
    if (queryString.startsWith('?') || queryString.startsWith('#')) {
        queryString = queryString.substring(1);
    }
    const vars = queryString.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        let key = decodeURIComponent(pair[0] || '');
        if (key.startsWith('?'))
            key = key.substring(1);
        if (key === name)
            return decodeURIComponent(pair[1] || '');
    }
    return undefined;
};
export const setQuerystringParameter = (name, value) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(name, decodeURIComponent(value));
    const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
};
export const removeQuerystringParameter = (name) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    const newRelativePathQuery = window.location.pathname + url.search;
    history.pushState(null, '', newRelativePathQuery);
};
export const generatePathUrl = (root, pathname, inAuthorMode, search, state) => ({
    pathname: `${root}${pathname}`,
    search: new URLSearchParams(inAuthorMode ? Object.assign(Object.assign({}, search), { wcmmode: 'disabled' }) : search).toString(),
    state,
});
